import { useCorePermissions } from "spark-core-dx/hooks"
import { DashMessage } from "./DashMessage"

export const WelcomeMessage = () => {
    const { canEdit } = useCorePermissions();
    return (
        <DashMessage
            icon={"dashboard"}
            title={"Welcome to your Dashboard!"}
            description={
                canEdit('Dashboard') ?
                    "Create or open a dashboard to get started."
                    :
                    "Open a dashboard to get started."

            }
        />
    )
}